import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'app-auth-login',
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.css']
})
export class AuthLoginComponent implements OnInit {
  public loginInvalid = false;
  private returnUrl: string;
  private empID:string;
  private dept:string;
  private otp:string;

constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/dashboard';
    this.empID = this.route.snapshot.queryParams.UserName
    this.dept = this.route.snapshot.queryParams.Dept
    this.otp = this.route.snapshot.queryParams.OTP

    if(!this.empID)
      this.loginInvalid=true;
    else if(!this.dept)
      this.loginInvalid=true;
    else if(!this.otp)
      this.loginInvalid=true;
    else
      this.authService.login(this.empID, this.dept,this.otp)

    //wait 10s before saying invalid login request
    setTimeout(function() {
      // @ts-ignore
      this.loginInvalid = true;
    }.bind(this), 10000);

}

  ngOnInit(): void {
  }

}
